import { inject, Injectable } from '@angular/core';
import { FullIndexService } from '../../../../entities/full-index/service/full-index.service';
import { AlertService } from '../../../../core/util/alert.service';

@Injectable({ providedIn: 'root' })
export class TravomateFullIndexService extends FullIndexService {
  protected alertService = inject(AlertService);

  index(indexTypeName: string): void {
    const endpoint = this.applicationConfigService.getEndpointFor('api/v1/full-indices/index/' + indexTypeName);
    this.alertService.addAlert({
      type: 'info',
      message: 'Indexing started',
      translationKey: 'coreApiApp.fullIndex.alert.started',
    });
    this.http.post(endpoint, {}).subscribe({
      next: () => {
        this.alertService.addAlert({
          type: 'success',
          message: 'Indexing completed',
          translationKey: 'coreApiApp.fullIndex.alert.completed',
        });
      },
      error: () => {
        this.alertService.addAlert({
          type: 'danger',
          message: 'Indexing failed',
          translationKey: 'coreApiApp.fullIndex.alert.failed',
        });
      },
    });
  }
}
